import React, { useEffect, useState } from "react";
import { helper } from "../../lib/helper";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import VedioModel from "../../models/vedio.model";
import { Link } from "react-router-dom";

const Vedio = () => {
  const [data, setData] = useState();
  const [modal4, setModal4] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [vediolink, setVedioLink]= useState();
  const [model5, setModal5] = useState(false);
  const [id, setId] =useState();
  const [item,setItem]=useState();
 
  
  const toggleModal5 = () => {
    setModal5(!model5);
  };
  const toggleModal4 = () => {
    setModal4(!modal4);
  };
  
  const toggleModal1 = () => {
    setModal1(!modal1);
  };
const Addvediolist = async (event)=>{
  event.preventDefault();
  const form = new FormData(event.target);
  
  // Simulate adding new video
  const newVideo = {
    id: (data?.length + 1).toString(),
    title: form.get("title"),
    video_type: form.get("video_type"),
    description: form.get("description"),
    video: {
      videoName: form.get("video")?.name || "new_video.mp4",
      url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
    }
  };
  
  setTimeout(() => {
    setData(prevData => [...(prevData || []), newVideo]);
    helper.sweetalert.toast("Video added successfully", "success");
    setModal4(false);
  }, 500);
}
const Editvedio = async (event)=>{
  event.preventDefault();
  const form = new FormData(event.target);
  
  // Simulate editing video
  setTimeout(() => {
    setData(prevData => 
      prevData?.map(video => 
        video.id === id 
          ? {
              ...video,
              title: form.get("title") || video.title,
              video_type: form.get("video_type") || video.video_type,
              description: form.get("description") || video.description
            }
          : video
      )
    );
    helper.sweetalert.toast("Video updated successfully", "success");
    setModal1(false);
  }, 500);
}
const Deletevedio = async () =>{
  // Simulate deleting video
  setTimeout(() => {
    setData(prevData => prevData?.filter(video => video.id !== id));
    helper.sweetalert.toast("Video deleted successfully", "success");
  }, 500);
}
  const getListData = async () => {
    // Dummy data for video list
    const dummyVideoData = [
      {
        id: "1",
        title: "Mathematics Tutorial - Algebra Basics",
        video_type: "Tutor",
        description: "Complete guide to algebra fundamentals for Class 9 students. Covers linear equations, quadratic equations, and factorization.",
        video: {
          videoName: "algebra_basics.mp4",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
        }
      },
      {
        id: "2",
        title: "Physics Concepts - Motion and Force",
        video_type: "Tutor",
        description: "Understanding Newton's laws of motion with practical examples and real-world applications for Class 11 physics.",
        video: {
          videoName: "motion_force.mp4",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
        }
      },
      {
        id: "3",
        title: "Parent Guidance - Supporting Your Child's Studies",
        video_type: "Parent",
        description: "Tips and strategies for parents to help their children excel in academics and maintain a healthy study routine.",
        video: {
          videoName: "parent_guidance.mp4",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
        }
      },
      {
        id: "4",
        title: "Chemistry Lab - Acid Base Reactions",
        video_type: "Tutor",
        description: "Practical demonstration of acid-base reactions with safety precautions and theoretical explanations.",
        video: {
          videoName: "chemistry_lab.mp4",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
        }
      },
      {
        id: "5",
        title: "English Grammar - Tenses Made Easy",
        video_type: "Tutor",
        description: "Comprehensive explanation of all English tenses with examples and practice exercises for better understanding.",
        video: {
          videoName: "english_tenses.mp4",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
        }
      },
      {
        id: "6",
        title: "Parent Workshop - Creating Study Environment",
        video_type: "Parent",
        description: "How to create an effective study environment at home that promotes concentration and learning.",
        video: {
          videoName: "study_environment.mp4",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
        }
      }
    ];
    
    setTimeout(() => {
      setData(dummyVideoData);
    }, 1000);
  };
  useEffect(() => {
    getListData();
  }, []);
  console.log("tttttt",item)
  return (
    <>
      <div className="px-4 py-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Video List</h3>

                <div className="d-flex flex-row">
                  <Button
                    size="sm"
                    to="/admin/user/adduser"
                    style={{ backgroundColor: "#080278", color: "white" }}
                    onClick={toggleModal4}
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>
            </Card>
          </div>
        </Row>
        <Card className="shadow">
        <Row className="thead-light" style={{ border: "1px solid lightgray", margin: "3px",backgroundColor:"#f6f9fc" }} >
                <Col style={{alignItems:"center",display:"flex"}} md={1}>S.NO</Col>
                <Col style={{alignItems:"center",display:"flex"}} md={2}>Title</Col>
                <Col style={{alignItems:"center",display:"flex"}} md={2} scope="col">Video Type</Col>
                <Col scope="col" md={3}>Description</Col>
                <Col>Video Link</Col>
                <Col md={1} style={{alignItems:"center",justifyContent:"center",display:"flex"}}>
                  Action
                </Col>
              </Row>
        {data?.map((data, key) => {
        
          return (
            <>
              <Row style={{ borderTop: "1px solid lightgray", margin: "3px" }} key={key}>
                <Col style={{alignItems:"center",display:"flex"}} md={1}>{key + 1}</Col>
                <Col style={{alignItems:"center",display:"flex"}} md={2}>{data?.title}</Col>
                <Col style={{alignItems:"center",display:"flex"}} md={2} scope="col">{data?.video_type}</Col>
                <Col  md={3}>{data?.description}</Col>
                <Col style={{alignItems:"center",display:"flex"}} >
                
               <p style={{cursor:"pointer"}} onClick={()=>{
                //window.open(data?.video, "_blank")
                setVedioLink(data?.video)
                toggleModal5();
                }}>{data?.video?.videoName}</p>
              
                </Col>
                <Col md={1} style={{alignItems:"center",justifyContent:"center",display:"flex"}}>
                  <Link
                  onClick={()=>{
                    toggleModal1()
                    setItem(data);
                    setId(data?.id);}}
                    style={{
                     
                      fontSize: "15px",
                      color: "blue",
                      // backgroundColor: "#f5f5f5",
                      alignItems: "center",
                      display: "inline-block",
                     
                      // padding: "5px", // Optional: Add padding for better appearance
                      borderRadius: "30%", // Optional: Make it a circle
                    }}
                    id="eyeTooltip"
                  >
                    <i className="fa-solid fa-pen-to-square"></i>
                  </Link>

                  <UncontrolledTooltip placement="top" target="userTooltip">
                    Delete
                  </UncontrolledTooltip>
                  <p
                    style={{
                      margin: "0 8px",
                      fontSize: "15px",
                      color: "red",
                      cursor:"pointer",
                     
                      // backgroundColor: "#f5f5f5",
                      display: "inline-block",
                      // padding: "5px", // Optional: Add padding for better appearance
                      borderRadius: "20%", // Optional: Make it a circle
                    }}
                    onClick={()=>{
                      setId(data?.id);
                      Deletevedio();
                    }}
                    id="userTooltip"
                  >
                    <i className="fas fa-trash"></i>
                  </p>
                </Col>
              </Row>
            </>
          );
        })}</Card>
        {/*add vedio module */}
        <Modal isOpen={modal4} toggle={toggleModal4} size="lg">
          <ModalHeader toggle={toggleModal4}>
            <h4> Add Video </h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={Addvediolist}>
            <Row>
            <Col md={12}>
                <FormGroup>
                  <Label> Select video </Label>
                  <Input name="video" type="file" placeholder="Enter Title" style={{border: "1px solid #cad1d7",borderRadius: "0.375rem", padding:"4px"}} />
                </FormGroup>
              </Col>
            </Row>
           
            <Row>

              <Col md={6}>
                <FormGroup>
                  <Label>Title
                  </Label>
                  <Input type="text" name="title" placeholder="Enter Title" />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>
                      Video Type
                  </Label>
                  <Input name="video_type" type="select"  >
                  <option value="">Select</option>
                  <option value="Tutor">Tutor</option>
                  <option value="Parent">Parent</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
             {/* <Col md={6}>
                <FormGroup>
                  z<Label>VideoName
                  </Label>
                  <Input type="text" placeholder="Enter videoname" />
                </FormGroup>
              </Col>*/}
              <Col md={6}>
                <FormGroup>
                  <Label >Description
                  </Label>
                  <Input name="description" type="text" placeholder="Enter Description" />
                </FormGroup>
              </Col>
            </Row>
            
            
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal4}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                }}
                
              >
                Save
              </Button>
            </div>
            </Form>
          </ModalBody>
        </Modal>
        {/*end*/}
        {/*Edit module*/}
        <Modal isOpen={modal1} toggle={toggleModal1} size="lg">
          <ModalHeader toggle={toggleModal1}>
            <h4> Video</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={Editvedio}>
            <Row>
            <Col md={12}>
                <FormGroup>
                  <Label> Select video </Label>
                  <Input name="video" type="file"  style={{border: "1px solid #cad1d7",borderRadius: "0.375rem", padding:"4px"}} />
                </FormGroup>
              </Col>
            </Row>
            {/*<Row>
            <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail"> Select vedio thumnail </Label>
                  <Input name="" type="file" placeholder="Enter Name" style={{border: "1px solid #cad1d7",borderRadius: "0.375rem",padding:"4px"}} />
                </FormGroup>
              </Col>
            </Row>*/}
            <Row>

              <Col md={6}>
                <FormGroup>
                  <Label>Title
                  </Label>
                  <Input name="title" type="text" placeholder="Enter Title" defaultValue={item?.title}/>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>
                      Video Type
                  </Label>
                  <Input name="video_type" type="text" placeholder="Enter Type" defaultValue={item?.video_type} />
                </FormGroup>
              </Col>
            </Row>
           
            <Row>
              {/*<Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Video Name
                  </Label>
                  <Input type="text" placeholder="Enter video name" />
                </FormGroup>
              </Col>*/}
              <Col md={6}>
                <FormGroup>
                  <Label >Description
                  </Label>
                  <Input name="description" type="text" placeholder="Enter Description" defaultValue={item?.description}/>
                </FormGroup>
              </Col>
            </Row>
           
            
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                }}
                // onClick={}
              >
                Save
              </Button>
            </div>
            </Form>
          </ModalBody>
        </Modal>
        {/*end*/}
        {/*popup vedio*/}
        <Modal isOpen={model5} toggle={toggleModal5} size="lg">
        <ModalHeader toggle={toggleModal5}>
            <h4>Video</h4>
          </ModalHeader>
          <ModalBody >
           
           <video src={vediolink?.videolink} style={{maxWidth:"100%"}} controls autoplay/>
          </ModalBody></Modal>
      </div>
    </>
  );
};

export default Vedio;
